// #2121 v2 - Modal pequeño con el historial completo de derivaciones de un estudio.
// Lee el estudio del store por id (selectedReportId del modal de history).
import React, { useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Badge } from 'reactstrap';
import { useTranslate } from 'react-translate';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { actionCloseHistory } from 'store/actions/deviceStudiesActions';

const DerivationHistoryModal = () => {
  const dispatch = useDispatch();
  const t        = useTranslate('device-studies');

  const { historyOpen, historyStudyId, studies, assignableDoctors } = useSelector(
    (s) => s.deviceStudiesReducer
  );

  const study = useMemo(
    () => studies.find((s) => String(s._id) === String(historyStudyId)),
    [studies, historyStudyId]
  );

  // Mapea auth_user_id → nombre completo (cache rápido para mostrar quién derivó)
  const doctorNameMap = useMemo(() => {
    const m = {};
    (assignableDoctors || []).forEach((d) => {
      m[String(d.auth_user_id)] = `${d.firstName} ${d.lastName}`;
    });
    return m;
  }, [assignableDoctors]);

  const onClose = () => dispatch(actionCloseHistory());

  if (!study) return null;

  const derivations = study.derivations || [];

  return (
    <Modal isOpen={historyOpen} toggle={onClose} autoFocus>
      <ModalHeader toggle={onClose}>{t('history-title')}</ModalHeader>
      <ModalBody>
        {/* Encabezado del estudio */}
        <div className="mb-3 pb-2 border-bottom">
          <strong>
            {study.patient_data?.lastName}, {study.patient_data?.firstName}
          </strong>
          {study.device_type && (
            <Badge color="info" className="ml-2">
              {study.device_type}
            </Badge>
          )}
          <div className="text-muted small">
            {t('history-received')}: {moment(study.created_at).format('DD.MM.YYYY HH:mm')}
          </div>
        </div>

        {/* Timeline de derivaciones */}
        {derivations.length === 0 ? (
          <p className="text-muted">{t('history-none')}</p>
        ) : (
          <ul className="list-unstyled m-0">
            {derivations.map((d, i) => {
              const isLast = i === derivations.length - 1;
              return (
                <li key={i} className="mb-3 d-flex" style={{ gap: 12 }}>
                  {/* Punto del timeline */}
                  <div style={{ position: 'relative', width: 12, flexShrink: 0 }}>
                    <span
                      style={{
                        display: 'block',
                        width: 12,
                        height: 12,
                        borderRadius: '50%',
                        background: isLast ? '#5e72e4' : '#aaa',
                        marginTop: 4,
                      }}
                    />
                    {!isLast && (
                      <span
                        style={{
                          position: 'absolute',
                          top: 16,
                          left: 5,
                          width: 2,
                          height: 'calc(100% + 4px)',
                          background: '#ddd',
                        }}
                      />
                    )}
                  </div>
                  {/* Contenido */}
                  <div className="flex-grow-1">
                    <div>
                      <strong>{t('history-assigned-to')}:</strong>{' '}
                      {doctorNameMap[String(d.doctor_id)] || d.doctor_id}
                    </div>
                    <div className="text-muted small">
                      {t('history-by')}: {doctorNameMap[String(d.assigned_by)] || d.assigned_by}
                      {' · '}
                      {moment(d.assigned_at).format('DD.MM.YYYY HH:mm')}
                    </div>
                    {d.note && (
                      <div className="mt-1 p-2" style={{ background: '#f7f8fa', borderRadius: 4, fontSize: '0.875rem' }}>
                        {d.note}
                      </div>
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>{t('modal-cancel')}</Button>
      </ModalFooter>
    </Modal>
  );
};

export default DerivationHistoryModal;
// #2121 - End
